import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import DailyMeals from '../Components/DailyMeals/DailyMeals'; // renamed import
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";   // ✅ correct import

function AboutPage() { // renamed component
    return (
        <>
        <Helmet>
                <title>Daily Veg Meal Delivery in Coimbatore | Homemade Food by Tickling Tummy</title>
                <meta name="description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, offering healthy and fresh daily meal subscriptions in R.S. Puram. Enjoy home-cooked lunches and dinners." />
                <meta name="keywords" content="Daily meals Coimbatore, Homemade vegetarian food, Pure veg lunch Coimbatore, Hygienic daily food, Meal subscription Coimbatore, Healthy lunch delivery" />
                <link rel="canonical" href="https://ticklingtummy.com/daily-meals" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="Daily Veg Meal Delivery in Coimbatore | Homemade Food by Tickling Tummy" />
                <meta property="og:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, offering healthy and fresh daily meal subscriptions in R.S. Puram. Enjoy home-cooked lunches and dinners." />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/daily-veg-meal-subscription-coimbatore.jpg" />
                <meta property="og:url" content="https://ticklingtummy.com/daily-meals" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Daily Veg Meal Delivery in Coimbatore | Homemade Food by Tickling Tummy" />
                <meta name="twitter:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, offering healthy and fresh daily meal subscriptions in R.S. Puram. Enjoy home-cooked lunches and dinners." />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/daily-veg-meal-subscription-coimbatore.jpg" />
            </Helmet>

        <script type="application/ld+json">
        {JSON.stringify([
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://ticklingtummy.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Daily Meals",
                "item": "https://ticklingtummy.com/daily-meals"
              }
            ]
          },
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Daily Veg Meal Subscription",
            "description": "Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, offering healthy and fresh daily meal subscriptions in R.S. Puram. Enjoy home-cooked lunches and dinners.",
            "provider": {
              "@type": "LocalBusiness",
              "name": "Tickling Tummy",
              "image": "https://ticklingtummy.com/assets/images/tickling-tummy-logo-coimbatore.svg"
            },
            "areaServed": {
              "@type": "City",
              "name": "Coimbatore"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Daily Meal Plans",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Weekly Meal Plan"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Monthly Meal Plan"
                  }
                }
              ]
            }
          }
        ], null, 2)}
        </script>

            <HeaderOne />
            <DailyMeals />
            <Footer />
        </>
    );
}

export default AboutPage;
